import { Component, Input } from '@angular/core';
import { Share, UserDetail } from '@ca/core/models';
import { ExperimentalFeaturesService, ResultsService, UserNotificationService } from '@ca/core/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EMPTY } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'ca-result-group-share-with-user-modal',
    templateUrl: './result-group-share-with-user-modal.component.html',
    styleUrls: ['./result-group-share-with-user-modal.component.scss'],
})
export class ResultGroupShareWithUserModalComponent {
    @Input() share: Share;

    constructor(
        private activeModal: NgbActiveModal,
        private resultsService: ResultsService,
        private userNotificationService: UserNotificationService,
        private experimentalFeaturesService: ExperimentalFeaturesService,
    ) {}

    save(share: Share): void {
        this.userNotificationService.showSpinner();
        if (this.experimentalFeaturesService.isMEDProjectActive) {
            this.resultsService
                .shareGroupsResult$(
                    share.id,
                    'User',
                    share.users.map((user: UserDetail) => user.id),
                )
                .pipe(
                    tap(() => {
                        this.userNotificationService.hideSpinner();
                        this.userNotificationService.showSuccess('MY_WORKSPACE.MY_RESULTS.SHARING.SUCCESS');
                        this.activeModal.close(share.users);
                    }),
                    catchError(() => {
                        this.userNotificationService.hideSpinner();
                        this.userNotificationService.showError('MY_WORKSPACE.MY_RESULTS.SHARING.ERROR');
                        return EMPTY;
                    }),
                    untilDestroyed(this),
                )
                .subscribe();
        } else {
            this.resultsService
                .shareResult$(
                    share.id,
                    'User',
                    share.users.map((user: UserDetail) => user.id),
                )
                .pipe(
                    tap(() => {
                        this.userNotificationService.hideSpinner();
                        this.userNotificationService.showSuccess('MY_WORKSPACE.MY_RESULTS.SHARING.SUCCESS');
                        this.activeModal.close(share.users);
                    }),
                    catchError(() => {
                        this.userNotificationService.hideSpinner();
                        this.userNotificationService.showError('MY_WORKSPACE.MY_RESULTS.SHARING.ERROR');
                        return EMPTY;
                    }),
                    untilDestroyed(this),
                )
                .subscribe();
        }
    }

    dismiss(): void {
        this.activeModal.dismiss();
    }
}
